import { Link } from 'react-router-dom';
import { GrayArrow } from '../../../../../../../assets/images/shopping';
import { IconArrow } from '../../../../../../../assets/DesignSystem/SVGComponents';
import { NudosTextInput, BordResponsibleUser } from '../../../../../../../components/NudosComponents';
import { IGeneralData } from '../../../../../../../types/orders';
import useUsersState from '../../../../../../../state/useUsersState';
import { IbackofficeUserData } from '../../../../../../../types/configuration.types';
import { IResponsibleUserData } from '../../../../../../../types/responsibleUser.types';
import './OrganizationInfoSection.scss';

const OrganizationInfoSection = ({
  orderGeneralData,
  orderId,
  responsibleUsersList,
  handleAssignOrderResponsible,
  handleDeleteOrderResponsible,
  loadingResponsibleUsersList,
  loadingStates
}: {
  orderGeneralData?: IGeneralData;
  orderId?: number;
  responsibleUsersList: IResponsibleUserData[];
  handleAssignOrderResponsible: (user: IbackofficeUserData) => Promise<void>;
  handleDeleteOrderResponsible: (responsibleId?: number, userName?: string) => Promise<void>;
  loadingResponsibleUsersList: boolean;
  loadingStates: boolean;
}) => {
  const { users } = useUsersState();

  const { orgData } = orderGeneralData || {};
  const { organizationId, organizationName, countryOrganization } = orgData || {};

  const noDataText = 'Sin datos';

  const seeOrganizationRedirectionData = {
    pathname: `/organization/details/${organizationId}`,
    state: {
      originUrl: `/order/details/${orderId}`
    }
  };

  return (
    <div className="organizationInfoSection">
      <div className="titlesSection">
        <div className="generalTitle">Información de empresa</div>
        {organizationId && (
          <Link className="seeOrganization" to={seeOrganizationRedirectionData}>
            <div>Ver empresa </div>
            <IconArrow className="IconArrow" />
          </Link>
        )}
      </div>
      <div className="organizationData">
        <div className="organizationDetails">
          <div className="containerFlag">
            <div className="countryTitle">País*</div>
            <div className="containerCountry">
              <div className="myFlag" style={{ backgroundImage: `url(${countryOrganization?.flag})` }} />
              <div className="floatArrow">
                <GrayArrow />
              </div>
            </div>
          </div>
          <div className="organizationName">
            <NudosTextInput
              isDeactivated
              label="Nombre de la empresa"
              defaultValue={organizationName || noDataText}
              isFilled
              placeholder="Nombre de la empresa"
              fontSize={12}
              styleLabel="customInputLabel"
            />
          </div>
          <BordResponsibleUser
            allUsersList={users}
            orderId={orderId}
            responsibleUsersList={responsibleUsersList}
            handleAssignResponsible={handleAssignOrderResponsible}
            handleDeleteResponsible={handleDeleteOrderResponsible}
            showResponsibleUsersSkeletonLoader={loadingResponsibleUsersList}
            isLoading={loadingStates}
          />
        </div>
      </div>
    </div>
  );
};

export default OrganizationInfoSection;
